import cn from "classnames";
import styles from "./Skeleton.module.scss";

export const Skeleton = ({ short, width, height, className }: {
  short?: boolean,
  className?: string,
  width?: string;
  height?: string;
}) => {
  let w = short ? (height ?? width) : width;
  let h = short ? (height ?? width) : height;
  return (
    <div
      className={cn(styles.skeleton, short && styles.short, className)}
      style={{
        width: w,
        height: h,
      }}
    />
  );
};
